import { render, staticRenderFns } from "./allotinList.vue?vue&type=template&id=0af2f2fc&scoped=true"
import script from "./allotinList.vue?vue&type=script&lang=js"
export * from "./allotinList.vue?vue&type=script&lang=js"
import style0 from "./allotinList.vue?vue&type=style&index=0&id=0af2f2fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af2f2fc",
  null
  
)

export default component.exports